import SHAREBOX_I32_CHECK_OUT_STEPS from './i32';

const SHAREBOX_W64_CHECK_OUT_STEPS = SHAREBOX_I32_CHECK_OUT_STEPS;

export default SHAREBOX_W64_CHECK_OUT_STEPS;
